import * as React from 'react';
import * as styles from './ActionButtonsDesktop.css';
import { PayAndPublishContainer } from './components';
import { SaveDraftContainer } from '../SaveDraft';

export const ActionButtonsDesktop = () => {
  return (
    <>
      <div className={styles['button_wrapper']}>
        <PayAndPublishContainer />
      </div>

      <div className={styles['button_wrapper']}>
        <SaveDraftContainer />
      </div>
    </>
  );
};
